import React from "react";
import { Banner, Text } from "../../../../components";

const BannerTipografia = () => {
  return (
    <Banner sectionName="Banner Catalogo" variant="secondary">
      <Text size="lg">Abaixo alguns exemplos sobre a tipografia</Text>
    </Banner>
  );
};

BannerTipografia.propTypes = {};

export default BannerTipografia;
